export const deviceType = [
    {
        id: 2,
        name:'VGPS_CAR4G'
    },
    {
        id: 3,
        name:'VGPS_MOTO4G'
    },
    {
        id: 4,
        name:'VGPS_HUM4G'
    },
    {
        id: 5,
        name:'VGPS_MAG4G'
    },
    {
        id: 6,
        name:'VGPS_ODB4G'
    },
    {
        id: 7,
        name:'VGPS_2CAM'
    },
    {
        id: 8,
        name:'VGPS_4CAM'
    },
]
